export var generateHistoryLabel = function (label, _a) {
    var isMobile = _a.isMobile;
    return "".concat(label, " - updated").concat(isMobile ? ' for a mobile mode' : '');
};
//# sourceMappingURL=generateHistoryLabel.js.map